import {
  normalizeBrandAccentColor
} from "./chunk-2PN7YULH.js";
import {
  DEFAULT_CUSTOM_PRODUCT_BRAND
} from "./chunk-O4NHF6EL.js";

// src/product-brand.ts
function productBrandLabel(config) {
  if (config.label) return config.label;
  const prefix = config.prefix ?? "Exxat";
  return `${prefix} ${config.suffix}`.replace(/\s+/g, " ").trim();
}
function defineProductBrand(input) {
  return {
    ...input,
    prefix: (input.prefix ?? "Exxat").trim(),
    suffix: input.suffix.trim()
  };
}
var EXXAT_LOGO_PINK = "#E31C79";
var EXXAT_LOGO_PINK_GRADIENT_END = "#EF609D";
var EXXAT_LOGO_PINK_SHADOW = "#BE1E6D";
var EXXAT_ONE_ACCENT = "oklch(57.84% 0.1560 279.93)";
var EXXAT_PRISM_ACCENT = "oklch(60.07% 0.2312 0.68)";
var EXXAT_ONE_SHARED = {
  prefix: "Exxat",
  suffix: "One",
  brandColor: EXXAT_ONE_ACCENT,
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
};
var EXXAT_ONE_SITES_BRAND = defineProductBrand({
  ...EXXAT_ONE_SHARED,
  id: "exxat-one-sites"
  // No `label` override — prefix + suffix compose "Exxat One".
});
var EXXAT_PRISM_BRAND = defineProductBrand({
  id: "exxat-prism",
  prefix: "Exxat",
  // The id and `/prism` URLs are unchanged; only what a human reads moved to
  // "Clinical Education". `label` overrides the composed "Exxat Clinical
  // Education", which is a mouthful in a sidebar lock-up.
  suffix: "Clinical Education",
  label: "Clinical Education",
  brandColor: EXXAT_PRISM_ACCENT,
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_CURRICULUM_MAPPING_BRAND = defineProductBrand({
  id: "exxat-curriculum-mapping",
  prefix: "Exxat",
  suffix: "Curriculum Mapping",
  label: "Curriculum Mapping",
  brandColor: "oklch(58% 0.15 195)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_COMPLIANCE_BRAND = defineProductBrand({
  id: "exxat-compliance",
  prefix: "Exxat",
  suffix: "Compliance",
  label: "Compliance",
  brandColor: "oklch(56% 0.13 155)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_SURVEYS_BRAND = defineProductBrand({
  id: "exxat-surveys",
  prefix: "Exxat",
  suffix: "Surveys",
  label: "Surveys & Course Evaluations",
  brandColor: "oklch(60% 0.15 55)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_EXAM_MANAGEMENT_BRAND = defineProductBrand({
  id: "exxat-exam-management",
  prefix: "Exxat",
  suffix: "Exam Management",
  label: "Exam Management",
  brandColor: "oklch(55% 0.14 300)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_ACCREDITATION_BRAND = defineProductBrand({
  id: "exxat-accreditation",
  prefix: "Exxat",
  suffix: "Accreditation",
  label: "Accreditation",
  brandColor: "oklch(54% 0.13 240)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_STUDENT_SUCCESS_BRAND = defineProductBrand({
  id: "exxat-student-success",
  prefix: "Exxat",
  suffix: "Student Success",
  label: "Student & Program Success",
  brandColor: "oklch(57% 0.15 85)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_DESIGN_OS_BRAND = defineProductBrand({
  id: "exxat-design-os",
  prefix: "Exxat",
  suffix: "Design OS",
  label: "Design OS",
  brandColor: "oklch(52% 0.14 264)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_ADMIN_BRAND = defineProductBrand({
  id: "exxat-admin",
  prefix: "Exxat",
  suffix: "Administrator",
  label: "Administrator",
  brandColor: "oklch(45% 0.035 265)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_PEOPLE_BRAND = defineProductBrand({
  id: "exxat-people",
  prefix: "Exxat",
  suffix: "People",
  label: "People",
  brandColor: "oklch(48% 0.06 250)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_COURSES_BRAND = defineProductBrand({
  id: "exxat-courses",
  prefix: "Exxat",
  suffix: "Courses",
  label: "Courses",
  brandColor: "oklch(50% 0.08 230)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
var EXXAT_PERSONNEL_BRAND = defineProductBrand({
  id: "exxat-personnel",
  prefix: "Exxat",
  suffix: "Personnel",
  label: "Personnel",
  brandColor: "oklch(47% 0.05 280)",
  wordmarkColor: EXXAT_LOGO_PINK,
  markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
  markShadow: EXXAT_LOGO_PINK_SHADOW
});
function customProductBrandConfig(customBrand = DEFAULT_CUSTOM_PRODUCT_BRAND) {
  const rawSuffix = customBrand?.suffix?.trim() || DEFAULT_CUSTOM_PRODUCT_BRAND.suffix;
  const suffix = rawSuffix.slice(0, 24).trim();
  const brandColor = normalizeBrandAccentColor(
    customBrand?.brandColor?.trim() || DEFAULT_CUSTOM_PRODUCT_BRAND.brandColor
  );
  return defineProductBrand({
    id: "exxat-custom",
    prefix: "Exxat",
    suffix,
    brandColor,
    wordmarkColor: EXXAT_LOGO_PINK,
    markGradient: [EXXAT_LOGO_PINK, EXXAT_LOGO_PINK_GRADIENT_END],
    markShadow: EXXAT_LOGO_PINK_SHADOW
  });
}
function brandPreviewPanelSurfaces(brandColor, dark) {
  const color = normalizeBrandAccentColor(brandColor);
  if (dark) {
    return {
      background: `oklch(from ${color} 0.26 max(0.028, calc(c * 0.30)) h)`,
      borderColor: `oklch(from ${color} 0.38 max(0.022, calc(c * 0.18)) h)`
    };
  }
  return {
    background: `oklch(from ${color} 0.965 max(0.018, calc(c * 0.22)) h)`,
    borderColor: `oklch(from ${color} 0.90 max(0.024, calc(c * 0.26)) h)`
  };
}
function applyBrandColorOverride(config, color) {
  const next = color?.trim();
  if (!next) return config;
  return { ...config, brandColor: next };
}
var REGISTRY = /* @__PURE__ */ new Map();
function registerProductBrand(config) {
  REGISTRY.set(config.id, config);
}
function getProductBrand(id) {
  return REGISTRY.get(id);
}
function listProductBrands() {
  return Array.from(REGISTRY.values());
}
registerProductBrand(EXXAT_ONE_SITES_BRAND);
registerProductBrand(EXXAT_PRISM_BRAND);
registerProductBrand(EXXAT_CURRICULUM_MAPPING_BRAND);
registerProductBrand(EXXAT_COMPLIANCE_BRAND);
registerProductBrand(EXXAT_SURVEYS_BRAND);
registerProductBrand(EXXAT_EXAM_MANAGEMENT_BRAND);
registerProductBrand(EXXAT_ACCREDITATION_BRAND);
registerProductBrand(EXXAT_STUDENT_SUCCESS_BRAND);
registerProductBrand(EXXAT_DESIGN_OS_BRAND);
registerProductBrand(EXXAT_ADMIN_BRAND);
registerProductBrand(EXXAT_PEOPLE_BRAND);
registerProductBrand(EXXAT_COURSES_BRAND);
registerProductBrand(EXXAT_PERSONNEL_BRAND);
registerProductBrand(customProductBrandConfig());
function brandForProduct(product, customBrand, productBrandColors) {
  const base = product === "exxat-custom" ? customProductBrandConfig(customBrand) : getProductBrand(product) ?? EXXAT_PRISM_BRAND;
  if (product === "exxat-custom") return base;
  return applyBrandColorOverride(base, productBrandColors?.[product]);
}

export {
  productBrandLabel,
  defineProductBrand,
  EXXAT_ONE_SITES_BRAND,
  EXXAT_PRISM_BRAND,
  EXXAT_CURRICULUM_MAPPING_BRAND,
  EXXAT_COMPLIANCE_BRAND,
  EXXAT_SURVEYS_BRAND,
  EXXAT_EXAM_MANAGEMENT_BRAND,
  EXXAT_ACCREDITATION_BRAND,
  EXXAT_STUDENT_SUCCESS_BRAND,
  EXXAT_DESIGN_OS_BRAND,
  EXXAT_ADMIN_BRAND,
  EXXAT_PEOPLE_BRAND,
  EXXAT_COURSES_BRAND,
  EXXAT_PERSONNEL_BRAND,
  customProductBrandConfig,
  brandPreviewPanelSurfaces,
  applyBrandColorOverride,
  registerProductBrand,
  getProductBrand,
  listProductBrands,
  brandForProduct
};
